export var CoreBadgeType;
(function(CoreBadgeType) {
    CoreBadgeType["GLASS"] = "glass";
    CoreBadgeType["EMERALD"] = "emerald";
    CoreBadgeType["DIAMOND"] = "diamond";
    CoreBadgeType["HYPE"] = "TheHype";
})(CoreBadgeType || (CoreBadgeType = {}));
export var AwardBadgeSource;
(function(AwardBadgeSource) {
    AwardBadgeSource["THUMB_OVERLAY"] = "thumb_overlay";
    AwardBadgeSource["THUMB_INFO"] = "thumb_info";
    AwardBadgeSource["ACTIONBAR_MORE"] = "actionbar_more";
    AwardBadgeSource["ACTIONBAR_BUTTON"] = "actionbar_button";
    AwardBadgeSource["COMMENT"] = "comment";
    AwardBadgeSource["PREVIEW"] = "preview";
})(AwardBadgeSource || (AwardBadgeSource = {}));

//# sourceMappingURL=types.js.map